import { defineMessages } from "@formatjs/intl";

export const messages = defineMessages({
  title: {
    id: `lms.guide05.p1.title`,
  },

  theoryTitle: {
    id: `lms.guide05.p1.theory.title`,
  },

  theoryDescription: {
    id: `lms.guide05.p1.theory.description`,
  },
  githubLinkName: {
    id: `lms.guide05.p1.github-link`,
  },
  audioHint: {
    id: `lms.guide05.p1.audio-hint`,
  },
});
